
import React, { useState } from 'react';
import axios from 'axios';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import env from "../../env.json";








const Step4 = ({ onBack, reportData, generatePayoutFile, selectedEntries }) => {
    const [selectedBank, setSelectedBank] = useState('Ujjivan Bank');
    const [isGenerating, setIsGenerating] = useState(false);

    // Filter only matched entries (both 'Matched' and 'NA' status)
    const matchedEntries = selectedEntries || [];

    const { BASE_URL } = env;

    console.log('matchedEntries=======', matchedEntries);

    function formatDateUTC(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        timeZone: "UTC", // prevents shifting to IST
      });
    }



    // Helper function to identify cash transactions
    const isCashTransaction = (entry) =>
        entry.transactionId.includes('CASH') && entry.status === 'NA';


    // Calculate totals from matched entries
    const calculateMatchedTotals = () => {
        // const isCashTransaction = (entry) => 
        //     entry.transactionId.includes('CASH') && entry.status === 'NA';

        // Calculate totals
        const totalCollected = matchedEntries.reduce((sum, entry) => sum + entry.customerAmount, 0);

        // Cash transactions (amount + platform fee + GST)
        const cashTransactions = matchedEntries
            .filter(isCashTransaction)
            .reduce((sum, entry) => ({
                amount: sum.amount + entry.customerAmount,
                platformFee: sum.platformFee + (entry.platformEarnings || 0),
                platformTax: sum.platformTax + (entry.platformTax || 0),
                totalCashDeductions: sum.totalCashDeductions + (entry.platformEarnings || 0) + (entry.platformTax || 0)
            }), { amount: 0, platformFee: 0, platformTax: 0, totalCashDeductions: 0 });

        // Digital transactions (amount + gateway + platform fee + GST)
        const digitalTransactions = {
            amount: matchedEntries
                .filter(entry => !isCashTransaction(entry))
                .reduce((sum, entry) => sum + entry.customerAmount, 0),
            gatewayCharges: matchedEntries
                .filter(entry => !isCashTransaction(entry))
                .reduce((sum, entry) => sum + (entry.gatewayCharges || 0), 0),
            platformFee: matchedEntries
                .filter(entry => !isCashTransaction(entry))
                .reduce((sum, entry) => sum + (entry.platformEarnings || 0), 0),
            platformTax: matchedEntries
                .filter(entry => !isCashTransaction(entry))
                .reduce((sum, entry) => sum + (entry.platformTax || 0), 0)
        };

        // Correct calculation flow:
        // 1. Subtract cash transaction amounts
        const amountAfterCash = totalCollected - cashTransactions.amount;

        // 2. Subtract all digital deductions
        const amountAfterDigitalDeductions = amountAfterCash
            - digitalTransactions.gatewayCharges
            - digitalTransactions.platformFee
            - digitalTransactions.platformTax


        // 3. Subtract cash platform fees (to be collected from JMAX)

        console.log(' cashTransactions.totalCashDeductions', cashTransactions.totalCashDeductions)
        const amountAfterAllDeductions = amountAfterDigitalDeductions - cashTransactions.totalCashDeductions;

        console.log(' camountAfterAllDeductions', amountAfterAllDeductions)
        // cashTransactions.totalCashDeductions
        // 4. Calculate TCS on the remaining amount
        const tcsAmount = totalCollected * 0.01;
        // const tcsAmount = amountAfterAllDeductions * 0.01;
        const finalPayableAmount = amountAfterAllDeductions - tcsAmount;

        return {
            totalCollected,
            cashTransactions,
            digitalTransactions,
            amountAfterCash,
            amountAfterDigitalDeductions,
            amountAfterAllDeductions,
            tcsAmount,
            finalPayableAmount
        };
    };

    // Use these values in your component
    const {
        totalCollected,
        cashTransactions,
        digitalTransactions,
        amountAfterAllDeductions,
        tcsAmount,
        finalPayableAmount
    } = calculateMatchedTotals();











    const hasCashTransactions = cashTransactions.amount > 0;
    const numberOfBeneficiaries = matchedEntries.length;

    // Amount calculations
    const amountAfterCashDeduction = totalCollected - cashTransactions.amount;
    const amountAfterDeductions = amountAfterCashDeduction - digitalTransactions.gatewayCharges - digitalTransactions.platformFee - digitalTransactions.platformTax;
    // const tcsAmount = amountAfterDeductions * 0.02;
    // const finalPayableAmount = amountAfterDeductions - tcsAmount;

    // Date range
    // const startDate = reportData?.periodStart ? new Date(reportData.periodStart).toLocaleDateString('en-IN') : 'N/A';
    // const endDate = reportData?.periodEnd ? new Date(reportData.periodEnd).toLocaleDateString('en-IN') : 'N/A';


    // const startDate = new Date(reportData.periodStart).toISOString().split("T")[0];
    // const endDate = new Date(reportData.periodEnd).toISOString().split("T")[0];

    const startDate = formatDateUTC(reportData.periodStart);
const endDate = formatDateUTC(reportData.periodEnd);



    //     const receiptHTML = `
    //     <html>
    //       <head>
    //         <title>Payment Receipt</title>
    //         <style>
    //           body {
    //             font-family: Arial, sans-serif;
    //             margin: 40px;
    //             color: #000;
    //           }
    //           table {
    //             width: 100%;
    //             border-collapse: collapse;
    //           }
    //           td {
    //             padding: 6px 4px;
    //             vertical-align: top;
    //           }
    //           .amount {
    //             text-align: right;
    //           }
    //           .negative {
    //             color: #e53e3e;
    //           }
    //           .bold {
    //             font-weight: bold;
    //           }
    //           .double-border {
    //             border-top: 3px double #000;
    //             margin-top: 10px;
    //           }
    //           .top-border {
    //             border-top: 1px solid #000;
    //           }
    //         </style>
    //       </head>
    //       <body>
    //         <h2>Cruze-WMD Services India Pvt Ltd.</h2>
    //         <h3>JSW Payment Receipt</h3>
    //         <p>Date: ${new Date().toLocaleDateString('en-IN')}</p>
    //         <br/>
    //         <table>
    //           <tr>
    //             <td>
    //               Total Transactions Amount <br/>
    //               (Cash & UPI/PhonePe) collected for Movie<br/>
    //               Tickets from ${startDate} to ${endDate}
    //             </td>
    //             <td class="amount">₹${totalCollected.toFixed(2)}</td>
    //           </tr>

    //           ${hasCashTransactions ? `
    //             <tr>
    //               <td>Tickets purchased & paid @Jmax by Cash /JSW UPI</td>
    //               <td class="amount negative">- ₹${cashTransactions.amount.toFixed(2)}</td>
    //             </tr>
    //           ` : ''}

    //           <tr>
    //             <td>Payment Gateway Charge deductions</td>
    //             <td class="amount negative">- ₹${digitalTransactions.gatewayCharges.toFixed(2)}</td>
    //           </tr>
    //           <tr>
    //             <td>Platform fee deductions</td>
    //             <td class="amount negative">- ₹${digitalTransactions.platformFee.toFixed(2)}</td>
    //           </tr>
    //           <tr>
    //             <td>Platform fee - GST</td>
    //             <td class="amount negative">- ₹${digitalTransactions.platformTax.toFixed(2)}</td>
    //           </tr>

    //           ${hasCashTransactions ? `
    //             <tr>
    //               <td>Platform fee & GST to be collected from JMAX for cash transactions</td>
    //               <td class="amount negative">- ₹${cashTransactions.totalCashDeductions.toFixed(2)}</td>
    //             </tr>
    //           ` : ''}

    //           <tr class="top-border">
    //             <td class="bold">
    //               Total Amount after ALL deductions
    //             </td>
    //             <td class="amount bold">₹${amountAfterAllDeductions.toFixed(2)}</td>
    //           </tr>

    //           <tr>
    //             <td>
    //               Tax collection at source by <br/>
    //               Cruze-WMD Services India Pvt Ltd. - TCS - 2%
    //             </td>
    //             <td class="amount negative">- ₹${tcsAmount.toFixed(2)}</td>
    //           </tr>

    //           <tr class="double-border bold">
    //             <td>
    //               Total Amount with GST to be paid to JSW for tickets period<br/>
    //               ${startDate} - ${endDate}
    //             </td>
    //             <td class="amount">₹${finalPayableAmount.toFixed(2)}</td>
    //           </tr>
    //         </table>
    //       </body>
    //     </html>
    //     `;


    //     const blob = new Blob([receiptHTML], { type: 'text/html' });
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = `JSW_Payment_Receipt_${startDate}_to_${endDate}.html`;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    //     URL.revokeObjectURL(url);
    // };

    // const receiptHTML = `
    // <html>
    //   <head>
    //     <title>JSW Payment Receipt</title>
    //     <style>
    //       body { font-family: Arial, sans-serif; margin: 40px; color: #000; }
    //       h2, h3, h4 { margin: 12px 0; }
    //       table { width: 100%; border-collapse: collapse; margin-top: 15px; }
    //       th, td {
    //         border: 1px solid #ddd;
    //         padding: 8px;
    //         font-size: 13px;
    //       }
    //       th { background-color: #f2f2f2; }
    //       .amount { text-align: right; }
    //       .negative { color: #e53e3e; }
    //       .bold { font-weight: bold; }
    //       .summary-table td { border: none; padding: 6px 0; }
    //       .double-border { border-top: 3px double #000; margin-top: 10px; }
    //       .top-border { border-top: 1px solid #000; }
    //     </style>
    //   </head>
    //   <body>
    //     <h2>Cruze-WMD Services India Pvt Ltd.</h2>
    //     <h3>JSW Payment Receipt</h3>
    //     <p><strong>Date:</strong> ${new Date().toLocaleDateString('en-IN')}</p>
    //     <p><strong>Period:</strong> ${startDate} to ${endDate}</p>

    //     <table class="summary-table">
    //       <tr>
    //         <td>Total Transactions Amount (Cash & UPI/PhonePe)</td>
    //         <td class="amount">₹${totalCollected.toFixed(2)}</td>
    //       </tr>
    //       ${hasCashTransactions ? `
    //       <tr>
    //         <td>Tickets purchased & paid @Jmax by Cash /JSW UPI</td>
    //         <td class="amount negative">- ₹${cashTransactions.amount.toFixed(2)}</td>
    //       </tr>` : ''}
    //       <tr>
    //         <td>Payment Gateway Charge deductions</td>
    //         <td class="amount negative">- ₹${digitalTransactions.gatewayCharges.toFixed(2)}</td>
    //       </tr>
    //       <tr>
    //         <td>Platform fee deductions</td>
    //         <td class="amount negative">- ₹${digitalTransactions.platformFee.toFixed(2)}</td>
    //       </tr>
    //       <tr>
    //         <td>Platform fee - GST</td>
    //         <td class="amount negative">- ₹${digitalTransactions.platformTax.toFixed(2)}</td>
    //       </tr>
    //       ${hasCashTransactions ? `
    //       <tr>
    //         <td>Platform fee & GST to be collected from JMAX (Cash)</td>
    //         <td class="amount negative">- ₹${cashTransactions.totalCashDeductions.toFixed(2)}</td>
    //       </tr>` : ''}
    //       <tr class="top-border bold">
    //         <td>Total Amount after ALL deductions</td>
    //         <td class="amount">₹${amountAfterAllDeductions.toFixed(2)}</td>
    //       </tr>
    //       <tr>
    //         <td>TCS @ 1% (Cruze-WMD)</td>
    //         <td class="amount negative">- ₹${tcsAmount.toFixed(2)}</td>
    //       </tr>
    //       <tr class="double-border bold">
    //         <td>Total Amount payable to JSW</td>
    //         <td class="amount">₹${finalPayableAmount.toFixed(2)}</td>
    //       </tr>
    //     </table>

    //     <h4>Transaction Breakdown – Cash Transactions</h4>
    //     <table>
    //       <thead>
    //         <tr>
    //           <th>Transaction ID</th>
    //           <th>Amount</th>
    //           <th>Theatre Base</th>
    //           <th>Theatre GST</th>
    //           <th>Platform Fee</th>
    //           <th>Platform GST</th>
    //           <th>Gateway Charges</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         ${matchedEntries.filter(entry => entry.transactionId.startsWith('CASH')).map(entry => `
    //           <tr>
    //             <td>${entry.transactionId}</td>
    //             <td class="amount">₹${entry.customerAmount.toFixed(2)}</td>
    //             <td class="amount">₹${(entry.baseAmount || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.taxes || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.platformTax || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
    //           </tr>
    //         `).join('')}
    //       </tbody>
    //     </table>

    //     <h4 style="margin-top:30px;">Transaction Breakdown – Digital Transactions</h4>
    //     <table>
    //       <thead>
    //         <tr>
    //           <th>Transaction ID</th>
    //           <th>Amount</th>
    //           <th>Theatre Base</th>
    //           <th>Theatre GST</th>
    //           <th>Platform Fee</th>
    //           <th>Platform GST</th>
    //           <th>Gateway Charges</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         ${matchedEntries.filter(entry => !entry.transactionId.startsWith('CASH')).map(entry => `
    //           <tr>
    //             <td>${entry.transactionId}</td>
    //             <td class="amount">₹${entry.customerAmount.toFixed(2)}</td>
    //             <td class="amount">₹${(entry.baseAmount || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.taxes || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.platformTax || 0).toFixed(2)}</td>
    //             <td class="amount">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
    //           </tr>
    //         `).join('')}
    //       </tbody>
    //     </table>
    //   </body>
    // </html>
    // `;



    // HTML Format 
    // const downloadReceipt = () => {
    //     const receiptHTML = `
    //     <html>
    //       <head>
    //         <title>JSW Payment Receipt</title>
    //         <style>
    //           body { font-family: Arial, sans-serif; margin: 40px; color: #000; }
    //           h2, h3, h4 { margin: 12px 0; }
    //           table { width: 100%; border-collapse: collapse; margin-top: 15px; }
    //           th, td {
    //             border: 1px solid #ddd;
    //             padding: 8px;
    //             font-size: 13px;
    //           }
    //           th { background-color: #f2f2f2; }
    //           .amount { text-align: right; }
    //           .negative { color: #e53e3e; }
    //           .bold { font-weight: bold; }
    //           .summary-table td { border: none; padding: 6px 0; }
    //           .double-border { border-top: 3px double #000; margin-top: 10px; }
    //           .top-border { border-top: 1px solid #000; }
    //         </style>
    //       </head>
    //       <body>
    //         <h2>Cruze-WMD Services India Pvt Ltd.</h2>
    //         <h3>JSW Payment Receipt</h3>
    //         <p><strong>Date:</strong> ${new Date().toLocaleDateString('en-IN')}</p>
    //         <p><strong>Period:</strong> ${startDate} to ${endDate}</p>
      
    //         <table class="summary-table">
    //           <tr>
    //             <td>Total Transactions Amount (Cash & UPI/PhonePe)</td>
    //             <td class="amount">₹${totalCollected.toFixed(2)}</td>
    //           </tr>
    //           ${hasCashTransactions ? `
    //           <tr>
    //             <td>Tickets purchased & paid @Jmax by Cash /JSW UPI</td>
    //             <td class="amount negative">- ₹${cashTransactions.amount.toFixed(2)}</td>
    //           </tr>` : ''}
    //           <tr>
    //             <td>Payment Gateway Charge deductions</td>
    //             <td class="amount negative">- ₹${digitalTransactions.gatewayCharges.toFixed(2)}</td>
    //           </tr>
    //           <tr>
    //             <td>Platform fee deductions</td>
    //             <td class="amount negative">- ₹${digitalTransactions.platformFee.toFixed(2)}</td>
    //           </tr>
    //           <tr>
    //             <td>Platform fee - GST</td>
    //             <td class="amount negative">- ₹${digitalTransactions.platformTax.toFixed(2)}</td>
    //           </tr>
    //           ${hasCashTransactions ? `
    //           <tr>
    //             <td>Platform fee & GST to be collected from JMAX (Cash)</td>
    //             <td class="amount negative">- ₹${cashTransactions.totalCashDeductions.toFixed(2)}</td>
    //           </tr>` : ''}
    //           <tr class="top-border bold">
    //             <td>Total Amount after ALL deductions</td>
    //             <td class="amount">₹${amountAfterAllDeductions.toFixed(2)}</td>
    //           </tr>
    //           <tr>
    //             <td>TCS @ 1% (Cruze-WMD)</td>
    //             <td class="amount negative">- ₹${tcsAmount.toFixed(2)}</td>
    //           </tr>
    //           <tr class="double-border bold">
    //             <td>Total Amount payable to JSW</td>
    //             <td class="amount">₹${finalPayableAmount.toFixed(2)}</td>
    //           </tr>
    //         </table>
      
    //         <h4>Transaction Breakdown – Cash Transactions</h4>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th>Transaction ID</th>
    //               <th>Amount</th>
    //               <th>Theatre Base</th>
    //               <th>Theatre GST</th>
    //               <th>Platform Fee</th>
    //               <th>Platform GST</th>
    //               <th>Gateway Charges</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             ${matchedEntries.filter(entry => entry.transactionId.startsWith('CASH')).map(entry => `
    //               <tr>
    //                 <td>${entry.transactionId}</td>
    //                 <td class="amount">₹${entry.customerAmount.toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.baseAmount || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.taxes || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformTax || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
    //               </tr>
    //             `).join('')}
    //           </tbody>
    //         </table>
      
    //         <h4 style="margin-top:30px;">Transaction Breakdown – Digital Transactions</h4>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th>Transaction ID</th>
    //               <th>Amount</th>
    //               <th>Theatre Base</th>
    //               <th>Theatre GST</th>
    //               <th>Platform Fee</th>
    //               <th>Platform GST</th>
    //               <th>Gateway Charges</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             ${matchedEntries.filter(entry => !entry.transactionId.startsWith('CASH')).map(entry => `
    //               <tr>
    //                 <td>${entry.transactionId}</td>
    //                 <td class="amount">₹${entry.customerAmount.toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.baseAmount || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.taxes || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformTax || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
    //               </tr>
    //             `).join('')}
    //           </tbody>
    //         </table>
    //       </body>
    //     </html>
    //     `;

    //     const blob = new Blob([receiptHTML], { type: 'text/html' });
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = `JSW_Payment_Receipt_${startDate}_to_${endDate}.html`;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    //     URL.revokeObjectURL(url);
    // };











// New pdf

    // const downloadReceipt = () => {
    //   const receiptHTML = `
    //     <div id="receiptContent" style="font-family: Arial, sans-serif; padding:20px;">
    //       <h2>Cruze-WMD Services India Pvt Ltd.</h2>
    //       <h3>JSW Payment Receipt</h3>
    //       <p><strong>Date:</strong> ${new Date().toLocaleDateString("en-IN")}</p>
    //       <p><strong>Period:</strong> ${startDate} to ${endDate}</p>
  
    //       <table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; margin-top: 15px; font-size:12px;">
    //         <tr>
    //           <td>Total Transactions Amount (Cash & UPI/PhonePe)</td>
    //           <td style="text-align:right;">₹${totalCollected.toFixed(2)}</td>
    //         </tr>
    //         ${
    //           hasCashTransactions
    //             ? `
    //         <tr>
    //           <td>Tickets purchased & paid @Jmax by Cash /JSW UPI</td>
    //           <td style="text-align:right; color:red;">- ₹${cashTransactions.amount.toFixed(
    //             2
    //           )}</td>
    //         </tr>`
    //             : ""
    //         }
    //         <tr>
    //           <td>Payment Gateway Charge deductions</td>
    //           <td style="text-align:right; color:red;">- ₹${digitalTransactions.gatewayCharges.toFixed(
    //             2
    //           )}</td>
    //         </tr>
    //         <tr>
    //           <td>Platform fee deductions</td>
    //           <td style="text-align:right; color:red;">- ₹${digitalTransactions.platformFee.toFixed(
    //             2
    //           )}</td>
    //         </tr>
    //         <tr>
    //           <td>Platform fee - GST</td>
    //           <td style="text-align:right; color:red;">- ₹${digitalTransactions.platformTax.toFixed(
    //             2
    //           )}</td>
    //         </tr>
    //         ${
    //           hasCashTransactions
    //             ? `
    //         <tr>
    //           <td>Platform fee & GST to be collected from JMAX (Cash)</td>
    //           <td style="text-align:right; color:red;">- ₹${cashTransactions.totalCashDeductions.toFixed(
    //             2
    //           )}</td>
    //         </tr>`
    //             : ""
    //         }
    //         <tr style="font-weight:bold; border-top:1px solid #000;">
    //           <td>Total Amount after ALL deductions</td>
    //           <td style="text-align:right;">₹${amountAfterAllDeductions.toFixed(
    //             2
    //           )}</td>
    //         </tr>
    //         <tr>
    //           <td>TCS @ 1% (Cruze-WMD)</td>
    //           <td style="text-align:right; color:red;">- ₹${tcsAmount.toFixed(
    //             2
    //           )}</td>
    //         </tr>
    //         <tr style="font-weight:bold; border-top:3px double #000;">
    //           <td>Total Amount payable to JSW</td>
    //           <td style="text-align:right;">₹${finalPayableAmount.toFixed(2)}</td>
    //         </tr>
    //       </table>
  
    //       <h4 style="margin-top:30px;">Transaction Breakdown – Cash Transactions</h4>
    //       <table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:12px;">
    //         <thead>
    //           <tr>
    //             <th>Transaction ID</th>
    //             <th>Amount</th>
    //             <th>Theatre Base</th>
    //             <th>Theatre GST</th>
    //             <th>Platform Fee</th>
    //             <th>Platform GST</th>
    //             <th>Gateway Charges</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           ${matchedEntries
    //             .filter((entry) => entry.transactionId.startsWith("CASH"))
    //             .map(
    //               (entry) => `
    //             <tr>
    //               <td>${entry.transactionId}</td>
    //               <td style="text-align:right;">₹${entry.customerAmount.toFixed(
    //                 2
    //               )}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.baseAmount || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.taxes || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.platformEarnings || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.platformTax || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.gatewayCharges || 0
    //               ).toFixed(2)}</td>
    //             </tr>
    //           `
    //             )
    //             .join("")}
    //         </tbody>
    //       </table>
  
    //       <h4 style="margin-top:30px;">Transaction Breakdown – Digital Transactions</h4>
    //       <table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:12px;">
    //         <thead>
    //           <tr>
    //             <th>Transaction ID</th>
    //             <th>Amount</th>
    //             <th>Theatre Base</th>
    //             <th>Theatre GST</th>
    //             <th>Platform Fee</th>
    //             <th>Platform GST</th>
    //             <th>Gateway Charges</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           ${matchedEntries
    //             .filter((entry) => !entry.transactionId.startsWith("CASH"))
    //             .map(
    //               (entry) => `
    //             <tr>
    //               <td>${entry.transactionId}</td>
    //               <td style="text-align:right;">₹${entry.customerAmount.toFixed(
    //                 2
    //               )}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.baseAmount || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.taxes || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.platformEarnings || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.platformTax || 0
    //               ).toFixed(2)}</td>
    //               <td style="text-align:right;">₹${(
    //                 entry.gatewayCharges || 0
    //               ).toFixed(2)}</td>
    //             </tr>
    //           `
    //             )
    //             .join("")}
    //         </tbody>
    //       </table>
    //     </div>
    //   `;
  
    //   // Create a temporary container
    //   const container = document.createElement("div");
    //   container.innerHTML = receiptHTML;
    //   document.body.appendChild(container);
  
    //   const element = container.querySelector("#receiptContent");
  
    //   html2canvas(element, { scale: 2 }).then((canvas) => {
    //     const imgData = canvas.toDataURL("image/png");
    //     const pdf = new jsPDF("p", "mm", "a4");
  
    //     // A4 size fit
    //     const pdfWidth = pdf.internal.pageSize.getWidth();
    //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
    //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    //     pdf.save(`JSW_Payment_Receipt_${startDate}_to_${endDate}.pdf`);
  
    //     document.body.removeChild(container); // cleanup
    //   });
    // };






// Auto table

const downloadReceipt = () => {
  const receiptHTML = `
    <div id="receiptContent" style="font-family: Arial, sans-serif; padding: 20px; background: white; width: 210mm; box-sizing: border-box;">
      <style>
        @media print, screen {
          #receiptContent {
            font-family: Arial, sans-serif;
            font-size: 12px;
            line-height: 1.4;
            color: #000;
            background: #fff;
            width: 210mm;
            min-height: 297mm;
            margin: 0;
            padding: 20px;
            box-sizing: border-box;
          }
          
          #receiptContent h2, #receiptContent h3, #receiptContent h4 {
            margin: 10px 0;
            padding: 0;
            page-break-after: avoid;
            page-break-inside: avoid;
          }
          
          #receiptContent h2 {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 5px;
          }
          
          #receiptContent h3 {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 15px;
          }
          
          #receiptContent h4 {
            font-size: 14px;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 10px;
          }
          
          #receiptContent p {
            margin: 5px 0;
            page-break-inside: avoid;
          }
          
          #receiptContent table {
            width: 100%;
            border-collapse: collapse;
            margin: 10px 0;
            page-break-inside: avoid;
            table-layout: fixed;
            font-size: 11px;
          }
          
          #receiptContent table th,
          #receiptContent table td {
            border: 1px solid #000;
            padding: 6px 8px;
            text-align: left;
            vertical-align: top;
            page-break-inside: avoid;
            word-wrap: break-word;
          }
          
          #receiptContent table th {
            background-color: #f5f5f5;
            font-weight: bold;
            text-align: center;
          }
          
          #receiptContent table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
          
          #receiptContent table tbody tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          
          #receiptContent .text-right {
            text-align: right !important;
          }
          
          #receiptContent .font-weight-bold {
            font-weight: bold !important;
          }
          
          #receiptContent .border-top-thick {
            border-top: 3px double #000 !important;
          }
          
          #receiptContent .border-top-single {
            border-top: 1px solid #000 !important;
          }
          
          #receiptContent .color-red {
            color: #d32f2f !important;
          }
        }
      </style>
      
      <h2>Cruze-WMD Services India Pvt Ltd.</h2>
      <h3>JSW Payment Receipt</h3>
      <p><strong>Date:</strong> ${new Date().toLocaleDateString("en-IN")}</p>
      <p><strong>Period:</strong> ${startDate} to ${endDate}</p>

      <table>
        <tbody>
          <tr>
            <td>Total Transactions Amount (Cash & UPI/PhonePe)</td>
            <td class="text-right">₹${totalCollected.toFixed(2)}</td>
          </tr>
          ${
            hasCashTransactions
              ? `
          <tr>
            <td>Tickets purchased & paid @Jmax by Cash /JSW UPI</td>
            <td class="text-right color-red">- ₹${cashTransactions.amount.toFixed(2)}</td>
          </tr>`
              : ""
          }
          <tr>
            <td>Payment Gateway Charge deductions</td>
            <td class="text-right color-red">- ₹${digitalTransactions.gatewayCharges.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Platform fee deductions</td>
            <td class="text-right color-red">- ₹${digitalTransactions.platformFee.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Platform fee - GST</td>
            <td class="text-right color-red">- ₹${digitalTransactions.platformTax.toFixed(2)}</td>
          </tr>
          ${
            hasCashTransactions
              ? `
          <tr>
            <td>Platform fee & GST to be collected from JMAX (Cash)</td>
            <td class="text-right color-red">- ₹${cashTransactions.totalCashDeductions.toFixed(2)}</td>
          </tr>`
              : ""
          }
          <tr class="border-top-single font-weight-bold">
            <td>Total Amount after ALL deductions</td>
            <td class="text-right">₹${amountAfterAllDeductions.toFixed(2)}</td>
          </tr>
          <tr>
            <td>TCS @ 1% (Cruze-WMD)</td>
            <td class="text-right color-red">- ₹${tcsAmount.toFixed(2)}</td>
          </tr>
          <tr class="border-top-thick font-weight-bold">
            <td>Total Amount payable to JSW</td>
            <td class="text-right">₹${finalPayableAmount.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>

      <h4>Transaction Breakdown – Cash Transactions</h4>
      <table>
        <thead>
          <tr>
            <th style="width: 20%;">Transaction ID</th>
            <th style="width: 12%;">Amount</th>
            <th style="width: 12%;">Theatre Base</th>
            <th style="width: 12%;">Theatre GST</th>
            <th style="width: 12%;">Platform Fee</th>
            <th style="width: 12%;">Platform GST</th>
            <th style="width: 12%;">Gateway Charges</th>
          </tr>
        </thead>
        <tbody>
          ${matchedEntries
            .filter((entry) => entry.transactionId.startsWith("CASH"))
            .map(
              (entry) => `
            <tr>
              <td>${entry.transactionId}</td>
              <td class="text-right">₹${entry.customerAmount.toFixed(2)}</td>
              <td class="text-right">₹${(entry.baseAmount || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.taxes || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.platformTax || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h4>Transaction Breakdown – Digital Transactions</h4>
      <table>
        <thead>
          <tr>
            <th style="width: 20%;">Transaction ID</th>
            <th style="width: 12%;">Amount</th>
            <th style="width: 12%;">Theatre Base</th>
            <th style="width: 12%;">Theatre GST</th>
            <th style="width: 12%;">Platform Fee</th>
            <th style="width: 12%;">Platform GST</th>
            <th style="width: 12%;">Gateway Charges</th>
          </tr>
        </thead>
        <tbody>
          ${matchedEntries
            .filter((entry) => !entry.transactionId.startsWith("CASH"))
            .map(
              (entry) => `
            <tr>
              <td>${entry.transactionId}</td>
              <td class="text-right">₹${entry.customerAmount.toFixed(2)}</td>
              <td class="text-right">₹${(entry.baseAmount || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.taxes || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.platformTax || 0).toFixed(2)}</td>
              <td class="text-right">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
    </div>
  `;

  // Create a temporary container with proper styling
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.left = "-9999px";
  container.style.top = "-9999px";
  container.style.width = "210mm";
  container.style.background = "white";
  container.innerHTML = receiptHTML;
  document.body.appendChild(container);

  const element = container.querySelector("#receiptContent");

  // Enhanced html2canvas options for better quality
  const canvasOptions = {
    scale: 2, // Higher scale for better quality
    useCORS: true,
    allowTaint: false,
    backgroundColor: "#ffffff",
    logging: false,
    width: element.scrollWidth,
    height: element.scrollHeight,
    scrollX: 0,
    scrollY: 0,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight
  };

  html2canvas(element, canvasOptions)
    .then((canvas) => {
      const imgData = canvas.toDataURL("image/png", 1.0);
      
      // Create PDF with proper A4 dimensions
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true
      });

      // Calculate dimensions to fit A4 properly
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      
      // Calculate scaling to fit width, maintaining aspect ratio
      const ratio = pdfWidth / canvasWidth;
      const scaledHeight = canvasHeight * ratio;

      // Add image to PDF
      if (scaledHeight <= pdfHeight) {
        // Single page
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, scaledHeight);
      } else {
        // Multiple pages
        let remainingHeight = scaledHeight;
        let yPosition = 0;
        
        while (remainingHeight > 0) {
          const pageHeight = Math.min(pdfHeight, remainingHeight);
          
          if (yPosition > 0) {
            pdf.addPage();
          }
          
          pdf.addImage(
            imgData, 
            "PNG", 
            0, 
            -yPosition * (pdfHeight / scaledHeight) * canvasHeight, 
            pdfWidth, 
            scaledHeight
          );
          
          remainingHeight -= pageHeight;
          yPosition += pageHeight;
        }
      }

      // Save the PDF
      pdf.save(`JSW_Payment_Receipt_${startDate}_to_${endDate}.pdf`);

      // Cleanup
      document.body.removeChild(container);
    })
    .catch((error) => {
      console.error("Error generating PDF:", error);
      document.body.removeChild(container);
    });
};

  





    // PDF 
    // const downloadReceipt = () => {
    //     const container = document.createElement('div');

    //     container.innerHTML = `
    //       <div style="width: 1000px; font-family: Arial, sans-serif; padding: 20px; color: #000;">
    //         <style>
    //           h2, h3, h4 { margin: 12px 0; }
    //           table { width: 100%; border-collapse: collapse; margin-top: 15px; table-layout: fixed; }
    //           th, td {
    //             border: 1px solid #ddd;
    //             padding: 6px;
    //             font-size: 12px;
    //             word-break: break-word;
    //           }
    //           th { background-color: #f2f2f2; }
    //           .amount { text-align: right; }
    //           .negative { color: #e53e3e; }
    //           .bold { font-weight: bold; }
    //           .summary-table td { border: none; padding: 6px 0; }
    //           .double-border { border-top: 3px double #000; margin-top: 10px; }
    //           .top-border { border-top: 1px solid #000; }
    //         </style>

    //         <h2>Cruze-WMD Services India Pvt Ltd.</h2>
    //         <h3>JSW Payment Receipt</h3>
    //         <p><strong>Date:</strong> ${new Date().toLocaleDateString('en-IN')}</p>
    //         <p><strong>Period:</strong> ${startDate} to ${endDate}</p>

    //         <table class="summary-table">
    //           <tr><td>Total Transactions Amount (Cash & UPI/PhonePe)</td><td class="amount">₹${totalCollected.toFixed(2)}</td></tr>
    //           ${hasCashTransactions ? `
    //           <tr><td>Tickets purchased & paid @Jmax by Cash /JSW UPI</td><td class="amount negative">- ₹${cashTransactions.amount.toFixed(2)}</td></tr>` : ''}
    //           <tr><td>Payment Gateway Charge deductions</td><td class="amount negative">- ₹${digitalTransactions.gatewayCharges.toFixed(2)}</td></tr>
    //           <tr><td>Platform fee deductions</td><td class="amount negative">- ₹${digitalTransactions.platformFee.toFixed(2)}</td></tr>
    //           <tr><td>Platform fee - GST</td><td class="amount negative">- ₹${digitalTransactions.platformTax.toFixed(2)}</td></tr>
    //           ${hasCashTransactions ? `
    //           <tr><td>Platform fee & GST to be collected from JMAX (Cash)</td><td class="amount negative">- ₹${cashTransactions.totalCashDeductions.toFixed(2)}</td></tr>` : ''}
    //           <tr class="top-border bold"><td>Total Amount after ALL deductions</td><td class="amount">₹${amountAfterAllDeductions.toFixed(2)}</td></tr>
    //           <tr><td>TCS @ 1% (Cruze-WMD)</td><td class="amount negative">- ₹${tcsAmount.toFixed(2)}</td></tr>
    //           <tr class="double-border bold"><td>Total Amount payable to JSW</td><td class="amount">₹${finalPayableAmount.toFixed(2)}</td></tr>
    //         </table>

    //         <h4>Transaction Breakdown – Cash Transactions</h4>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th>Transaction ID</th>
    //               <th>Amount</th>
    //               <th>Theatre Base</th>
    //               <th>Theatre GST</th>
    //               <th>Platform Fee</th>
    //               <th>Platform GST</th>
    //               <th>Gateway Charges</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             ${matchedEntries
    //               .filter(entry => entry.transactionId && entry.transactionId.toUpperCase().startsWith('CASH'))
    //               .map(entry => `
    //               <tr>
    //                 <td>${entry.transactionId}</td>
    //                 <td class="amount">₹${entry.customerAmount.toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.baseAmount || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.taxes || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformTax || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
    //               </tr>`).join('')}
    //           </tbody>
    //         </table>

    //         <h4 style="margin-top:30px;">Transaction Breakdown – Digital Transactions</h4>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th>Transaction ID</th>
    //               <th>Amount</th>
    //               <th>Theatre Base</th>
    //               <th>Theatre GST</th>
    //               <th>Platform Fee</th>
    //               <th>Platform GST</th>
    //               <th>Gateway Charges</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             ${matchedEntries
    //               .filter(entry => entry.transactionId && !entry.transactionId.toUpperCase().startsWith('CASH'))
    //               .map(entry => `
    //               <tr>
    //                 <td>${entry.transactionId}</td>
    //                 <td class="amount">₹${entry.customerAmount.toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.baseAmount || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.taxes || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformEarnings || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.platformTax || 0).toFixed(2)}</td>
    //                 <td class="amount">₹${(entry.gatewayCharges || 0).toFixed(2)}</td>
    //               </tr>`).join('')}
    //           </tbody>
    //         </table>
    //       </div>
    //     `;

    //     window.html2pdf()
    //       .set({
    //         margin: 5,
    //         filename: `JSW_Payment_Receipt_${startDate}_to_${endDate}.pdf`,
    //         image: { type: 'jpeg', quality: 0.98 },
    //         html2canvas: { scale: 2, useCORS: true },
    //         jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
    //       })
    //       .from(container)
    //       .save();
    //   };







// Working before committing the cash entries


    // const handleGenerate = async () => {
    //     if (!selectedBank) {
    //         alert("Please select a bank.");
    //         return;
    //     }
    //     // setIsGenerating(true);



    //     const confirmGenerate = window.confirm(
    //         "Do you really want to generate the payout? This will be considered as a final commit and the data will be marked as committed."
    //     );

    //     if (!confirmGenerate) return;

    //     setIsGenerating(true);


    //     const isCashTransaction = (entry) =>
    //         entry.transactionId.includes('CASH') && entry.status === 'NA';

    //     const payoutData = {
    //         ...reportData,
    //         summary: {
    //             ...reportData.summary,
    //             detailedEntries: matchedEntries.filter(entry => !isCashTransaction(entry))
    //         }
    //     };


    //     const allFinalEntries = matchedEntries; // includes both cash & digital

    //     // await axios.post('http://localhost:8080/commitPaymentData', {
    //     //     committedEntries: allFinalEntries.map(e => e._id),
    //     //     reportId: reportData._id  // optional
    //     // });


    //     // generatePayoutFile(selectedBank, payoutData);







    //     console.log('allFinalEntries=====', allFinalEntries);
    //     console.log('reportData  id=====', reportData._id);


    //     try {
    //         // 🔁 Mark all entries as committed
    //         await axios.post('http://localhost:8080/commitPaymentData', {
    //         // await axios.post('https://admin-api.cruze.asia/commitPaymentData', {
    //             transactionIds: matchedEntries.map(e => e.transactionId),
    //             reportId: reportData._id
    //         });

    //         // ✅ Continue with payout generation
    //         generatePayoutFile(selectedBank, payoutData);

    //         alert("✅ Entries committed and payout file generated.");
    //     } catch (error) {
    //         console.error("❌ Commit failed:", error);
    //         alert("Failed to commit entries.");
    //     }


    //     setIsGenerating(false);
    // };









    const handleGenerate = async () => {
        if (!selectedBank) {
          alert("Please select a bank.");
          return;
        }
      
        const confirmGenerate = window.confirm(
          "Do you really want to generate the payout? This will be considered as a final commit and the data will be marked as committed."
        );
      
        if (!confirmGenerate) return;
      
        setIsGenerating(true);
      
        const isCashTransaction = (entry) =>
          typeof entry.transactionId === 'string' &&
          entry.transactionId.startsWith('CASH') &&
          entry.status === 'NA';
      
        const allFinalEntries = matchedEntries;
        const nonCashEntries = matchedEntries.filter((entry) => !isCashTransaction(entry));
      
        const isOnlyCash = nonCashEntries.length === 0;
      
        try {
          // ✅ Always commit, regardless of type
          await axios.post(`${BASE_URL}/commitPaymentData`, {
          // await axios.post('http://localhost:8080/commitPaymentData', {
          // await axios.post('https://admin-api.cruze.asia/commitPaymentData', {
            transactionIds: matchedEntries.map(e => e.transactionId),
            reportId: reportData._id,
          });
      
          if (isOnlyCash) {
            alert("✅ Only cash entries found. Entries committed, but payout file was not generated.");
          } else {
            // ✅ Proceed with payout generation for non-cash
            const payoutData = {
              ...reportData,
              finalPayableAmount, // ✅ inject final amount
              summary: {
                ...reportData.summary,
                detailedEntries: nonCashEntries,
              },
            };
      
            generatePayoutFile(selectedBank, payoutData);
            alert("✅ Entries committed and payout file generated.");
          }
        } catch (error) {
          console.error("❌ Commit failed:", error);
          alert("Failed to commit entries.");
        }
      
        setIsGenerating(false);
      };
      


    return (
        <div>
            <h2 className="text-xl font-semibold mb-4">Step 3: Generate Payment Receipt</h2>

            {numberOfBeneficiaries === 0 && (
                <div className="mb-4 p-3 bg-yellow-100 text-yellow-800 rounded-md">
                    Warning: No matched transactions found. Payout file will be empty.
                </div>
            )}

            <div className="mb-6 bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex justify-between items-center mb-4">
                    <div>
                        <h4 className="text-lg font-medium">Cruze-WMD Services India Pvt Ltd.</h4>
                        <p className="text-sm text-gray-600">JSW Payment Receipt</p>
                    </div>
                    <button
                        onClick={downloadReceipt}
                        className="px-3 py-1 bg-blue-100 text-blue-700 rounded-md text-sm hover:bg-blue-200"
                    >
                        Download Settelement Report
                    </button>
                </div>

                <div className="text-sm space-y-3">
                    <div className="flex justify-between">
                        <span>Total Transactions Amount (Cash & UPI/PhonePe) collected for Movie Tickets from {startDate} to {endDate }</span>
                        <span className="font-mono">₹{totalCollected.toFixed(2)}</span>
                    </div>

                    {hasCashTransactions && (
                        <>
                            <div className="flex justify-between">
                                <span>Tickets purchased & paid @Jmax by Cash /JSW UPI</span>
                                <span className="font-mono text-red-600">- ₹{cashTransactions.amount.toFixed(2)}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Platform fee & GST to be collected from JMAX for cash transactions</span>
                                <span className="font-mono text-red-600">- ₹{cashTransactions.totalCashDeductions.toFixed(2)}</span>
                            </div>
                        </>
                    )}

                    <div className="flex justify-between">
                        <span>Payment Gateway Charge deductions</span>
                        <span className="font-mono text-red-600">- ₹{digitalTransactions.gatewayCharges.toFixed(2)}</span>
                    </div>

                    <div className="flex justify-between">
                        <span>Platform fee deductions</span>
                        <span className="font-mono text-red-600">- ₹{digitalTransactions.platformFee.toFixed(2)}</span>
                    </div>

                    <div className="flex justify-between">
                        <span>Platform fee - GST</span>
                        <span className="font-mono text-red-600">- ₹{digitalTransactions.platformTax.toFixed(2)}</span>
                    </div>

                    <div className="flex justify-between pt-2 border-t border-gray-300 font-medium">
                        <span>Total Amount after deducting cash transactions, Payment Gateway charges & Platform Fee/GST</span>
                        <span className="font-mono">₹{amountAfterAllDeductions.toFixed(2)}</span>
                    </div>

                    <div className="flex justify-between">
                        <span>Tax collection at source by Cruze-WMD Services India Pvt Ltd. - TCS - 1%</span>
                        <span className="font-mono text-red-600">- ₹{tcsAmount.toFixed(2)}</span>
                    </div>

                    <div className="flex justify-between pt-2 border-t-2 border-gray-400 font-bold">
                        <span>Total Amount with GST to be paid to JSW for tickets period {startDate} - {endDate}</span>
                        <span className="font-mono">₹{finalPayableAmount.toFixed(2)}</span>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-white p-4 rounded-md shadow-sm border">
                    <p className="text-sm text-gray-500">Total Collected Amount</p>
                    <p className="text-xl font-semibold">₹{totalCollected.toFixed(2)}</p>
                </div>
                <div className="bg-white p-4 rounded-md shadow-sm border">
                    <p className="text-sm text-gray-500">Cash Transactions</p>
                    <p className="text-xl font-semibold">₹{cashTransactions.amount.toFixed(2)}</p>
                </div>
                <div className="bg-white p-4 rounded-md shadow-sm border">
                    <p className="text-sm text-gray-500">Final Payable to JSW</p>
                    <p className="text-xl font-semibold">₹{finalPayableAmount.toFixed(2)}</p>
                </div>
            </div>

            <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-700">Payout Bank</label>
                <select
                    value={selectedBank}
                    onChange={(e) => setSelectedBank(e.target.value)}
                    className="w-full p-2 border rounded-md mb-4"
                    disabled
                >
                    <option value="Ujjivan Bank">Ujjivan Bank</option>
                </select>






                <div className="bg-blue-50 p-4 rounded-md">
                    <h4 className="font-medium mb-2">Payout File Details</h4>
                    <p className="text-sm text-gray-600 mb-2">
                        The payout file will contain {matchedEntries.filter(e => !isCashTransaction(e)).length} digital transactions.
                    </p>
                    {hasCashTransactions && (
                        <p className="text-sm text-gray-600">
                            <strong>Note:</strong> {matchedEntries.filter(isCashTransaction).length} cash transactions are excluded from payout file.
                        </p>
                    )}
                </div>
            </div>

            <div className="flex justify-between">
                <button
                    onClick={onBack}
                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                >
                    Back
                </button>
                <button
                    onClick={handleGenerate}
                    disabled={isGenerating || numberOfBeneficiaries === 0}
                    className={`px-4 py-2 rounded-md text-white ${isGenerating || numberOfBeneficiaries === 0 ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
                >
                    {isGenerating ? 'Generating...' : 'Generate Payout File'}
                </button>
            </div>
        </div>
    );
};
export default Step4;